import { useQuery } from '@tanstack/react-query';
import { GET_CONTENT_QUERY_KEY } from '~/queries/keys';
import { COMPARATOR_TYPES, searchApi } from '~/searchApi';

export const useGetContent = (contentId: string, shareToken?: string) => {
  return useQuery(
    [GET_CONTENT_QUERY_KEY, contentId],
    () =>
      searchApi.getContents(
        {
          filters: [
            {
              comparator: COMPARATOR_TYPES.EQ,
              name: 'id',
              value: contentId,
            },
          ],
        },
        shareToken,
      ),
    { enabled: !!contentId },
  );
};
